import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'

export const Route = createFileRoute('/_authenticated/workspaces/$subscriptionId/plan/cancel/confirm')({
  beforeLoad({ params: { subscriptionId } }) {
    throw redirect({
      to: AppRoute.SubscriptionCancellationSurvey,
      search: { step: 'confirm' },
      params: { subscriptionId },
    })
  },
})
